import React from 'react';
import { motion } from 'framer-motion';
const comparisons = [{
  bad: 'Frigorifero pieno ma nessuna idea.',
  good: 'Sai sempre cosa preparare in 2 minuti.'
}, {
  bad: 'Snack improvvisati e sensi di colpa.',
  good: 'Spuntini sani già pronti e pianificati.'
}, {
  bad: 'Ore in cucina ogni singola sera.',
  good: 'Meal Prep: organizzi la settimana in 90 min.'
}, {
  bad: 'Spesa caotica e costosa.',
  good: 'Lista della spesa pronta e ottimizzata.'
}, {
  bad: 'Sensazione di gonfiore costante.',
  good: 'Leggerezza reale dalla prima settimana.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-16 px-4 bg-brand-cream" data-id="element-44">
      <div className="max-w-xl mx-auto" data-id="element-45">
        <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 text-center" data-id="element-46">
          <div className="font-bold text-brand-text-muted text-xs sm:text-sm uppercase tracking-wider" data-id="element-47">
            SENZA IL METODO
          </div>
          <div className="font-bold text-brand-olive text-xs sm:text-sm uppercase tracking-wider" data-id="element-48">
            CON IL METODO MEDITERRANEO
          </div>
        </div>

        <div className="space-y-3" data-id="element-49">
          {comparisons.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="grid grid-cols-2 gap-3 sm:gap-4 bg-white border border-brand-sage/30 rounded-xl p-3 sm:p-4 items-center shadow-sm" data-id="element-50">
              <div className="text-brand-text-muted text-xs sm:text-sm pr-2 border-r border-brand-sage/30" data-id="element-51">
                {item.bad}
              </div>
              <div className="text-brand-olive font-bold text-xs sm:text-sm pl-2" data-id="element-52">
                {item.good}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}